<template>
  <page
    :back-to="getPreviousUrl"
    :title="publisher ? 'Publisher - #' + publisher.id : ''"
    size="is-tablet"
    :loading="publisher === null"
  >
    <div slot="page-header-right">
      <button class="button is-danger is-outlined mr-2" @click="destroy">Delete</button>

      <button @click="save" class="button is-primary" :class="{ 'is-loading': form.processing }">
        <span>Save Changes</span>
      </button>
    </div>

    <form @submit.prevent="save" v-if="form">
      <div class="box">
        <b-field style="margin-bottom: 1.5rem;">
          <div class="control">
            <b-radio v-model="form.type" native-value="organization">Organization</b-radio>

            <b-radio v-model="form.type" native-value="person">Person</b-radio>
          </div>
        </b-field>

        <hr />

        <div class="columns">
          <div class="column is-2">
            <media-image
              class="is-circle has-buttons-centered"
              model-type="App.Publishing.Publisher"
              :model-id="publisher.id"
              collection="photos"
              :default-image-src="
                    publisher.photo ? publisher.photo.md : null
                  "
              style="width: 80px; height: 80px;"
            ></media-image>
          </div>

          <div class="column">
            <div class="columns" v-if="form.type === 'person'">
              <div class="column">
                <b-field label="Last Name">
                  <b-input v-model="form.last_name"></b-input>
                </b-field>
              </div>

              <div class="column">
                <b-field label="Name">
                  <b-input v-model="form.first_name"></b-input>
                </b-field>
              </div>
            </div>

            <b-field :label="form.type === 'person' ? 'Full name' : 'Name'">
              <b-input v-model="form.name" expanded></b-input>
            </b-field>
          </div>
        </div>
      </div>

      <div class="box">
        <b-field label="About publisher">
          <b-input type="textarea" v-model="form.description"></b-input>
        </b-field>
      </div>

      <div class="is-pulled-right">
        <router-link
          :to="'/publishers/' + publisher.id"
          class="button mr-2"
          :disabled="form.processing"
        >Cancel</router-link>

        <button class="button is-primary" :class="{ 'is-loading': form.processing }">
          <span>Save Changes</span>
        </button>
      </div>
    </form>
  </page>
</template>

<script>
import MediaImage from "../../components/media-image/Index";

export default {
  components: {
    MediaImage
  },

  data() {
    return {
      publisher: null,

      form: null
    };
  },

  created() {
    this.load();
  },

  watch: {
    $route() {
      this.load();
    },

    publisher() {
      this.form = new window.Form({
        type: this.publisher.type,
        name: this.publisher.name,
        first_name: this.publisher.first_name,
        last_name: this.publisher.last_name,
        description: this.publisher.description
      });
    }
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  methods: {
    load() {
      this.$http
        .get("/admin/api/publishers/" + this.$route.params.id)
        .then(response => {
          this.publisher = response.data.data;
        })
        .catch(() => {
          alert("Couldn't fetch data from the server.");
        });
    },

    save() {
      this.form.put("/admin/api/publishers/" + this.publisher.id).then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully saved."
        });

        this.$router.push(`/publishers/${this.publisher.id}`);
      });
    },

    destroy() {
      this.$buefy.dialog.confirm({
        title: "Please confirm",
        message: "Are you sure to delete the publisher.",
        cancelText: "Cancel",
        confirmText: "Delete publisher",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$http
            .delete(`/admin/api/publishers/${this.$route.params.id}`)
            .then(() => {
              this.$buefy.toast.open({
                type: "is-success",
                message: "Амжилттай устгагдсан."
              });

              this.$router.push("/publishers");
            })
            .catch(error => {
              new window.FailedResponseHandler(error).handle();
            });
        }
      });
    }
  }
};
</script>
